import type { ComponentProps } from "react"
import { cx } from "~/lib/legacy-utils"

export const LogoSymbol = ({ className, ...props }: ComponentProps<"svg">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      role="img"
      aria-label="Logo"
      className={cx("h-5 w-auto shrink-0 fill-current", className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H128V128H48V48h80v80h80v80Z"
      />
    </svg>
  )
}
